import { iconNameMapping } from "../../features/iconmapping";
import { useData } from "../../dataProvider";
import HelpIcon from "@material-ui/icons/Help";
import Chip from "@material-ui/core/Chip";
import "../styles/heroesInfo.css";
import { paintBar } from "../../features/colorgenerator";
import Text from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Slider from "../ui/slider";
import Typography from "@material-ui/core/Typography";

const positions = ["carry", "mid", "offlane", "pos4", "pos5"];

const HeroesInfo = () => {
	const {
		herodata,
		direHeroData,
		lane_outcomes,
		direName,
		radiantName,
		stats,
		ywsAdvatnage,
	} = useData();

	//icons names
	const radiantNamesIcons = stats.map((item) =>
		iconNameMapping(Object.keys(item).join(""))
			.replace(/[\s-]/g, "_")
			.replace(/'/g, "")
			.toLowerCase()
	);
	const direNames = stats.find(
		(item) => Object.values(Object.values(item))[0] !== null
	);
	const direNamesIcons = Object.keys(Object.values(direNames)[0]).map((item) =>
		iconNameMapping(item).replace(/[\s-]/g, "_").replace(/'/g, "").toLowerCase()
	);

	const midData = lane_outcomes.mid.probability;
	const laneData = Object.entries(lane_outcomes).filter(
		([key]) => key !== "mid"
	);

	return (
		<Grid container spacing={2} direction="column">
			<Grid item xs={12}>
				<Typography noWrap variant="h6" align="center">
					{radiantName} vs {direName}
				</Typography>
			</Grid>
			<Grid
				item
				xs={12}
				container
				justify="center"
				style={{ padding: "2rem", margin: "1rem 0" }}
			>
				<div className="dota2_map">
					{herodata.reduce((prev, [heroname, advantage], index) => {
						const isOfflane = index === 2;
						const isMid = index === 1;

						const direPropability = midData && midData < 0;
						const radiantProbability = midData && midData > 0;

						const radiantHero = (
							<div
								className={`radiant_${positions[index]} position_on_map ${isOfflane && "reverse"
									}`}
							>
								{heroname === "unknown" ? (
									<HelpIcon fontSize="medium" />
								) : (
									<i className={`d2mh ${radiantNamesIcons[index]}`} />
								)}
								<div className={`${isMid && `${radiantProbability && "move_mid_probablity"} "mid_advantage_container"`}`}>
									{advantage !== null ? (
										<>
											<Chip
												label={advantage}
												style={{
													backgroundColor: paintBar(herodata[index][1]),
													zIndex: 2,
													position: 'relative',
												}}
											/>
											{radiantProbability && isMid && (
												<div className="mid_probability probability">
													<span className="midData">{Math.abs(midData)}</span>
												</div>
											)}
										</>
									) : (
										<div style={{ height: 32 }}></div>
									)}
								</div>
							</div>
						);

						prev.push(radiantHero);

						const direHero = (
							<div
								className={`dire_${positions[index]} position_on_map ${isOfflane && "reverse"
									}`}
							>
								<div
									className={`${isMid && `${direPropability && "move_mid_probablity"} "mid_advantage_container"`}`}
								>
									{direHeroData[index][1] !== null ? (
										<>
											{direPropability && isMid && (
												<div className="mid_probability probability">
													<span className="midData">{Math.abs(midData)}</span>
												</div>
											)}
											<Chip
												label={direHeroData[index][1]}
												style={{
													backgroundColor: paintBar(direHeroData[index][1]),
													zIndex: 2,
													position: 'relative',
												}}
											/>
										</>
									) : (
										<div style={{ height: 32 }}></div>
									)}
								</div>
								{direHeroData[index][0] === "unknown" ? (
									<HelpIcon fontSize="medium" />
								) : (
									<i className={`d2mh ${direNamesIcons[index]}`} />
								)}
							</div>
						);

						prev.push(direHero);

						return prev;
					}, [])}

					{console.log(laneData)}

					{laneData.map(([key, { probability }]) => {
						return probability !== null ? (
							<Chip
								className={`
									probability 
									probability_lanes 
									probability_${key}_${probability > 0 ? "radiant" : "dire"}
								`}
								label={
									<span className={`probability_text_${key}_${probability > 0 ? "radiant" : "dire"}`}>
										{Math.abs(probability)}
									</span>
								}
							/>
						) : null;
					})}
				</div>
			</Grid>
			<Grid item xs={12} container justify="center">
				<Grid item xs={12} md={10}>
					<Text variant="h6" align="center">
						Модель 1
					</Text>
					<Slider advanatge={ywsAdvatnage.toFixed(2)} max={30} />
				</Grid>
			</Grid>
		</Grid>
	);
};

export default HeroesInfo;
